
interface ValidationRuleProps {
  valid?: boolean;
  text: string;
  touched?: boolean;
}

export function ValidationRule({
  valid = false,
  text,
  touched = false,
}: ValidationRuleProps) {
  let icon = "/icons/ic-ideal.svg";
  let textColor = "text-gray-400";

  if (touched) {
    if (valid) {
      icon = "/icons/ic-success.svg";
      textColor = "text-green-500";
    } else {
      icon = "/icons/ic-failure.svg";
      textColor = "text-red-500";
    }
  }

  return (
    <div className="flex items-center gap-2 text-sm">
      <img src={icon} alt="validation rule" className="w-5 h-5" />
      <span className={textColor}>{text}</span>
    </div>
  );
}
